import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';
import { FocusRing } from '@change/ds-core-ui/util';
import { CheckIcon } from '@change/ds-icons/CheckIcon';
import { CopyIcon } from '@change/ds-icons/CopyIcon';

import { useStaffDrawerInfo } from './hooks/useStaffDrawerInfo';

type Props = {
	label: string;
	value: string;
	copyable?: boolean;
};

export const StaffDrawerInfo: React.FC<Props> = ({ label, value, copyable = false }) => {
	const {
		data: { copied },
		actions: { copyValue },
	} = useStaffDrawerInfo(value);

	return (
		<li className="flex items-center gap-1">
			<Text size="small">
				<Text size="small" fontWeight="bold">
					{label}:
				</Text>{' '}
				{value}
			</Text>
			{copyable && (
				<>
					{/* plain button: the ds Button forces its icons to `medium` */}
					<FocusRing>
						<button
							type="button"
							aria-label={`Copy ${label}`}
							onClick={() => void copyValue()}
							className="text-typography-weak hover:text-typography-strong inline-flex size-5 cursor-pointer items-center justify-center rounded-sm"
							data-qa="staff-drawer-info-copy"
						>
							{copied ? <CheckIcon size={14} /> : <CopyIcon size={14} />}
						</button>
					</FocusRing>
					<output className="sr-only">{copied ? `${label} copied` : ''}</output>
				</>
			)}
		</li>
	);
};
